import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

import T from '../i18n/i18n';
import { Window, Header, HeaderTitle, ButtonBar, Button, Background, Page, PageContent, PageText, PageHighlight, ResumeChart, CurrentValue, TargetValue, ChartBar } from './PopupDonate.styles';

export default (props) => {
    
    const [opened, setOpened] = useState(true);

    const playerId = useSelector(state => state.authState.id);
    const currentValue = useSelector(state => parseInt(state.profilesState.donate.current ?? '0', 10));
    const targetValue = useSelector(state => parseInt(state.profilesState.donate.target ?? '0', 10));
    const isPremium = useSelector(state => state.profilesState.isPremium);
    
    const close = () => {
        setOpened(false);
        localStorage.setItem('hide-popupdonate-' + playerId, String((new Date()).getTime()));
    }

    const handleDonate = () => {
        let a = document.createElement('a');
        a.setAttribute("href","https://apoia.se/hubrpg");
        a.setAttribute("target","_blank");
        a.setAttribute("id","goToDonate");
        document.querySelector('body').append(a);
        document.querySelector('#goToDonate').click();
        document.querySelector('body').removeChild(a);
    }

    useEffect(() => {
        let today = new Date();
        let lastViewDay = localStorage.getItem("config.donateview-"+playerId) ?? null;

        localStorage.setItem("config.donateview-"+playerId, new Date().getTime());
        
        let last = new Date(parseInt(lastViewDay, 10));
        let [tdYear, tdMonth, tdDay] = today.toISOString().substring(0,10).split('-');
        let [lastYear, lastMonth, lastDay] = last && !isNaN(last.getTime()) ? last.toISOString().substring(0,10).split('-') : [0,0,0];

        if (tdYear === lastYear && tdMonth === lastMonth && tdDay === lastDay) {
            setOpened(false);
        }
    }, []);

    return <>
        <Background className={opened && !isPremium ? 'opened' : ''} />
        <Window className={opened && !isPremium ? 'opened' : ''}>
            <Header>
                <HeaderTitle><T value={props.translate || "donate.title"}/></HeaderTitle>
            </Header>
            <Page>
                <PageContent className={"scrollbar"}>
                    <PageHighlight>"<T value="donate.text1" />"</PageHighlight>
                    <PageText><T value="donate.text2" /></PageText>
                    <ResumeChart>
                        <CurrentValue>R$ {currentValue} <span><T value="donate.current" /></span></CurrentValue>
                        <ChartBar percent={Math.round(100*currentValue/Math.max(1, targetValue))} />
                        <TargetValue><span><T value="donate.target" />:</span> R$ {targetValue}</TargetValue>
                    </ResumeChart>
                </PageContent>
            </Page>
            <ButtonBar>
                <div style={{flex: 1}}></div>
                <Button color={"#999"} onClick={() => {close()}}><T value="close" /></Button>
                <Button color={"#08f"} onClick={() => {handleDonate()}}><T value={"donate.donate"} /></Button>
            </ButtonBar>
        </Window>
    </>;

};